//#region src/assets/vana-square-logo.png
var vana_square_logo_default = "" + new URL("vana-square-logo-Ckf9thc-.png", import.meta.url).href;
//#endregion
export { vana_square_logo_default as default };

//# sourceMappingURL=vana-square-logo.js.map